export default{

    apiBaseURL : 'http://api.guillaume.corp.suivideflotte.net/',
    apiAuthUrl : 'http://selim.bellala.api-auth-layer.dev.corp.suivideflotte.net/api',

    apiVersion: 1,

    endpoints: {

        onboarding: 'onboarding',

        oauth: {
            login: 'users/login',
            google: 'oauth2/sso/google',
            logout: 'logout',
            refresh: 'users/refresh'
        },

        me: {
            me: 'me',
            permissions: 'me/acl'
        },

        user: {
            connected: 'beepiz/user',
            //connected: 'user/user.json'
        },

        users: {
            index: 'admin/users',
            add: 'admin/users',
            show: 'admin/users/{id}',
            edit: 'admin/users/{id}',
            delete: 'admin/users/{id}',
            roles: 'admin/users/{id}/roles',
            groups: 'admin/users/{id}/groups/{universe}',
            checkMailExists: 'me/client/alreadymail'
        },

        roles: {
            index: 'admin/acl/roles/{universe}'
        },

        groups: {
            index: 'admin/groups/{universe}'
        },


        interlocutor: {
            logo: 'me/client/logo',
            client: 'me/client/infos',
            contacts: 'me/client/contacts',
            invoices: 'me/client/invoices',
            drcs: 'admin/drc',
            drc: 'admin/drc/{iddrc}',
            viewDrcDocument : 'admin/drc/{iddrc}/document/{idAction}',
            postDrcComment: 'admin/drc/{iddrc}',
            dlInvoice: 'clients/downloadinvoice/{invoiceNumber}'
        },

        plugins: {
            categories: 'plugins/categories',
            providers: 'plugins/providers',
            library: 'plugins',
            configurations: 'plugins/configurations',
            show: 'plugins/{id}',
            edit: 'plugins/configurations/{id}',
            add: 'plugins/{id}',
            step: 'plugins/configurations/{id}/step/{step}',
            finalize: 'plugins/configurations/{id}/finalize',
            activation: 'plugins/configurations/{id}/activation',
            synchronize: 'plugins/configurations/{id}/synchronize',
            suggest: 'plugins/suggestion'
        }

    },

    route: function(route,params){
        var finalRoute = route;
        for(var paramKey in params){
            finalRoute = finalRoute.replace('{'+paramKey+'}',params[paramKey]);
        }
        return finalRoute;
    },
    constructQueryParams: function(options){
        var queryArray = [];

        if(options.fields != null && options.fields.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('fields',options.fields));
        }

        if(options.perpage){
            queryArray.push(this._constructQueryParamFragment('perpage',options.perpage));
        }

        if(options.page){
            queryArray.push(this._constructQueryParamFragment('page',options.page));
        }

        if(options.filter != null && options.filter.equals != null && options.filter.equals.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('equals',options.filter.equals));
        }

        if(options.filter != null && options.filter.like != null && options.filter.like.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('like',options.filter.like));
        }

        if(options.sort != null && options.sort.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('sort',options.sort).replace(/\+/g,''));
        }

        if(options.type != null && options.type.length > 0){
            queryArray.push(this._constructQueryParamArrayFragment('type',options.type));
        }

        return '?'+queryArray.join('&');
    },
    _constructQueryParamFragment: function(key, value){
        return key+'='+value;
    },
    _constructQueryParamArrayFragment: function(key, array){
        return key+'='+array.join(',');
    },

}



// WEBPACK FOOTER //
// ./src/services/API.js